<template>
    <div>
        <Loading type="line" :center="false" v-show="loading" />

        <template v-if="isUserTemp">
            <b-tabs>
                <b-tab title="Produto">
                    <ItemRentSection :itemsRent="itemsRent" :formName="formName" :statusStock="statusStock"
                        :statusInvoice="statusInvoice" :operational="operational" :isDisabledProduct="isDisabledProduct"
                        @clean-product="cleanProduct" />
                </b-tab>

                <b-tab>
                    <template #title>
                        <span style="color: red;">
                            <i class="fa-solid fa-triangle-exclamation"></i> Zona de Perigo
                        </span>
                    </template>

                    <b-col sm="12">
                        <RadioGroup title="Qual ação deseja realizar?" field="status" :stacked="true"
                            :options="optionsDangerZone" v-model="itemsRent.optionSelectedDangerZone" />
                    </b-col>
                </b-tab>
            </b-tabs>
        </template>

        <template v-else>
            <ItemRentSection :itemsRent="itemsRent" :operational="operational" :formName="formName"
                :showListKitOrAccessory="showListKitOrAccessory" :statusStock="statusStock"
                :statusInvoice="statusInvoice" :isDisabledProduct="isDisabledProduct" @clean-product="cleanProduct" />
        </template>

        <b-row>
            <b-col sm="12">
                <div class="div-btn text-right">
                    <Button _key="btnUpdateItemRent" type="success" title="Salvar"
                        :disabled="!isFormValid(formName) && !itemsRent.kitId" classIcon="fas fa-save" size="medium"
                        :clicked="saveItemRent" />
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import RadioGroup from "@nixweb/nixloc-ui/src/component/forms/RadioGroup.vue";

import ItemsRent from "@/components/modules/rental/new-items-rent/ItemsRent.js";
import ItemRentSection from "./ItemRentSection.vue";

import { mapGetters, mapActions, mapMutations, mapState } from "vuex";

export default {
    name: "ItemRentUpdate",
    props: {
        operational: { type: Boolean, default: false },
        origin: { type: String, default: "" },
        showListKitOrAccessory: { type: Boolean, default: false },
    },
    components: {
        Button,
        Loading,
        RadioGroup,
        ItemRentSection,
    },
    data() {
        return {
            formName: "itemRentUpdate",
            itemsRent: new ItemsRent(),
            urlUpdate: "/api/v1/rental/items-rent/update",
            loading: true,
            optionsDangerZone: [
                { text: "Corrigir Status", value: "forceMovementAdjustment" },
                { text: "Excluir Movimentação", value: "removeMovement" },
                { text: "Excluir Produto", value: "remove" },
                { text: "Nenhuma Ação", value: "none" },
            ],
        };
    },
    computed: {
        ...mapGetters("validation", ["isFormValid"]),
        ...mapGetters("generic", ["event"]),
        ...mapState("user", ["userLogged"]),
        statusStock() {
            return this.itemsRent.statusStockItemsRent;
        },
        statusInvoice() {
            return this.itemsRent.statusInvoiceItemsRent;
        },
        isDisabledProduct() {
            if (this.itemsRent.typeProduct.id == "") return true;
            if (this.statusStock == 1) return false;
            if (this.statusStock == 2) return false;
            return true;
        },
        isUserTemp() {
            return this.userLogged.user.userName == "UserTemp";
        },
    },
    methods: {
        ...mapActions("generic", ["putApi"]),
        ...mapMutations("generic", ["addEvent", "removeLoading", "hideModal"]),
        ...mapMutations("validation", ["resetValidation"]),
        saveItemRent() {
            let discount = this.itemsRent.discount;
            this.itemsRent.discountByPercentage = discount.discountByPercentage;
            this.itemsRent.unitDiscount = discount.discount;

            let periodRentIdOld = this.itemsRent.periodRentId;
            this.itemsRent.periodRentId = this.itemsRent.periodRent.id;
            this.itemsRent.productId = this.itemsRent.product.id;
            this.itemsRent.origin = this.origin;
            this.itemsRent.operational = this.operational;

            let params = { url: this.urlUpdate, obj: this.itemsRent };
            this.putApi(params).then((response) => {
                if (response.success) {
                    this.addEvent({
                        name: "addedProduct",
                        data: { showAll: false, period: { id: periodRentIdOld } },
                    });
                    this.addEvent({ name: "updateTotalizationRent" });
                    this.hideModal();
                }
                this.removeLoading(["btnUpdateItemRent"]);
            });
        },
        update(data) {
            this.itemsRent = new ItemsRent();
            this.itemsRent.update(data);
        },
        cleanProduct() {
            this.itemsRent.product = { id: "", content: "" };
        },
    },
    watch: {
        event: {
            handler(event) {
                if (event.name == "itemRentUpdate") {
                    this.update(event.data);
                    this.loading = true;
                    setTimeout(() => (this.loading = false), 300);
                }
            },
            deep: true,
        },
    },
};
</script>

<style scoped>
.div-btn {
    margin-top: 12px;
}
</style>
